import Column from "../grid/Column";
import Container from "../grid/Container";
import ErrorBoundary from "../ErrorBoundary";
import Footer from "../Footer";
import Header from "../Header";
import React, {useEffect} from "react";
import Row from "../grid/Row";
import styles from "./SubmittedFundLaterPage.module.css";
import TextLink from "../TextLink";
import usePageView from "../../lib/usePageView";

const strings = {
    title: "Application Submitted",
    p1:
        "Thank you for applying for a 1st Financial Bank USA Secured Card. We will remind you on the day you selected to fund your account.",
    p2:
        "We look forward to welcoming you as a customer and serving you for all the many years to come. You will soon receive a letter from us confirming the action taken on your application. If you have any questions, please call Customer Service at ",
    phone: "1-800-733-1732",
};

export default function SubmittedFundLaterPage() {
    useEffect(() => {
        document.title = strings.title;
    }, []);
    usePageView(strings.title);

    return (
        <ErrorBoundary>
            <Header />
            <Container className={styles.container}>
                <Row className={styles.titleRow}>
                    <Column>
                        <h1 className={styles.title}>{strings.title}</h1>
                    </Column>
                </Row>
                <Row className={styles.p1Row}>
                    <Column>
                        <div className={styles.paragraph}>{strings.p1}</div>
                    </Column>
                </Row>
                <Row className={styles.p2Row}>
                    <Column>
                        <div className={styles.paragraph}>
                            {strings.p2}
                            <TextLink
                                openInSameTab={true}
                                className={styles.link}
                                href="tel:800-733-1732"
                                text={strings.phone}
                            />
                        </div>
                    </Column>
                </Row>
            </Container>
            <Footer />
        </ErrorBoundary>
    );
}
